import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { permissionService } from '../api/services';
import { useAuth } from './AuthContext';

// 提供目前登入者的「有效功能權限」給前端各處做 UI 開關（例如是否顯示「開立懸賞」按鈕）。
// 後端為唯一權威：此處僅快取查詢結果，實際操作仍由後端再次驗證權限。
const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const { user } = useAuth();
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    // 未登入時清空權限
    if (!user) {
      setPermissions([]);
      return undefined;
    }
    setLoading(true);
    permissionService.me()
      .then((res) => { if (!cancelled) setPermissions(res.data?.permissions || []); })
      .catch(() => { if (!cancelled) setPermissions([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
    // 以使用者 id 為依賴，登入者改變時重新查詢
  }, [user]);

  const hasPermission = useCallback((key) => permissions.includes(key), [permissions]);

  return (
    <PermissionsContext.Provider value={{ permissions, hasPermission, loading }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within PermissionsProvider');
  }
  return context;
};
